"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Button = _interopRequireDefault(require("../../Button"));

var _defaultTheme = _interopRequireDefault(require("../../defaultTheme"));

var StyledButton = _styledComponents.default.div.withConfig({
  displayName: "ActiveButton__StyledButton",
  componentId: "sc-1j3a7nx-0"
})(["&:hover,&:active,&:focus{background:", ";color:", ";transform:none;cursor:default;}", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.orbit.backgroundButtonSecondary;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.orbit.colorTextButtonSecondary;
}, function (_ref3) {
  var transparent = _ref3.transparent;
  return transparent && (0, _styledComponents.css)(["&&&{background-color:transparent;box-shadow:none;}"]);
}); // $FlowFixMe: https://github.com/flow-typed/flow-typed/issues/3653#issuecomment-568539198


StyledButton.defaultProps = {
  theme: _defaultTheme.default
};

var ActiveButton = function ActiveButton(_ref4) {
  var children = _ref4.children,
      transparent = _ref4.transparent,
      size = _ref4.size;
  return /*#__PURE__*/React.createElement(_Button.default, {
    type: "secondary",
    size: size,
    asComponent: function asComponent(props) {
      return /*#__PURE__*/React.createElement(StyledButton, (0, _extends2.default)({}, props, {
        type: undefined,
        transparent: transparent
      }));
    }
  }, children);
};

var _default = ActiveButton;
exports.default = _default;